import { Component } from '@angular/core';
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import {TerminalService} from 'src/app/services/terminal.service'
import { DatePipe } from '@angular/common';
import {AirConfigService}  from 'src/app/services/air-config.service'
import { UserInfo, UserInfoService } from 'src/app/services/user-info.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { LoginService } from 'src/app/services/login.service';
import {PaymentConfigService}  from 'src/app/services/payment-config.service'

@Component({
  selector: 'app-ticket-issuance',
  templateUrl: './ticket-issuance.component.html',
  styleUrls: ['./ticket-issuance.component.css']
})
export class TicketIssuanceComponent {
  uuid:any
  username:any
  subs! : Subscription;
  sourceList:any=[]
  Officeid:any
  txt:any
  pnrNo:any
  fopType:any
  
  cardNo:any
  cardExpMonth:any
  cardCvv:any
  cardExpYear:any
  pnrDetails:any
  getSession:any
  ctDetails:any
  creationDate:any
  IATA:any
  fopAmt:any;
  hidebutton:boolean=false;
  getdataa:any
  isPopupHide:boolean=true
  errorNotfound:boolean=false
  constructor( private TerminalService:TerminalService,private userInfoService:UserInfoService,private AirConfigService:AirConfigService,
    private PaymentConfigService:PaymentConfigService,   private toastMsgService : ToastmsgService,
    ){this.creditList()
 //  this.Officeid="Office Id : DELVS319B"
 this.username=userInfoService.getUsername();

 console.log(this.username)

this.getSourceConfig()
  
  }
  
  getPnrDetails(){
   
    return new Promise<string[]>(() => {
      //setTimeout(() => {
        const patterns =/^[A-Za-z0-9]+$/;
  
    
    if(this.pnrNo==="12345"){
    this.hidebutton=true
    const Output = `--- TST RLR SFP --- \n
    RP/LONU126HJ/LONU126HJ   DL/RM 27APR21/2336Z 2QYWGC\n
    NYC1S2417/0004HS27AOR21 \n
    1.BELGRAVE/KINIA   2.PARRIS/MICHAEL \n
    3.DL1094 E 28MAY 5 LGAMCO HK2 0705 0953 28MAY E DL/HMZOCY\n
    4.DL 555 E 31MAY 1 MCOLGA HK2 0600 0839 31MAY EMAY E DL/HMZOCY\n
    5.AP B \n`;
   
    this.pnrDetails=Output}
    else if(this.pnrNo==="AN07OCTDELLHR"){
      this.hidebutton=true
      const Output = `--- AMADEUS AVAILABILITY --- \n
     
      1. AI 129 J1 Y9 M3 B9 Q30  DEL I LHR 1440 1645 0/330  0:00 `;
     
      this.pnrDetails=Output}
    else if(patterns.test(this.pnrNo)){
    
      
     let rtCommand=this.pnrNo
     console.log(rtCommand)
     
      this.getPnr(rtCommand);
      
       // this.terminalItems.push({ type: 'command', text: this.command });
     // this.terminalItems.push({ type: 'output', text: this.rtdata});
      //this.getdata()
    
    }
    else if(this.pnrNo==="KMB52M"){
      this.txt="TST/TSM/RLR"
      this.IATA="IATA CODE : 14363904"
      this.creationDate=`Created On : 14/7/23  06:30` 
      this.hidebutton=true
      this.pnrDetails=`PNR Number : KMB52M\xa0 Date : 14/07/2023\xa0   Time : 07:30   

Passenger Details     
Name : E A/JOLLY MR

Itinerary Details
Departure Date : 12/08/2023\xa0  Departure Time:13:30\xa0  Arrival Date :12/08/2023\xa0  Arrival Time :14:45
Origin : DEL \xa0 Destination : UDR \xa0 Status : HK 

Flight Details
Flight Number : UK-627(Vistara) \xa0  Numbers of Stops : 0 \xa0 Departure Terminal : 3 \xa0 CheckIn Time : 12:20

Fare Details
Fare: INR 9000

Form of payment : CASH \xa0 Contact Details : 919811783378/SAKHUJA.AYUSH@BCG.COM \xa0 TIcketing Carrier: UK

Ticket Number : 5005710028
`
     } 
   else if(this.pnrNo===""){
    this.pnrDetails=""
    this.hidebutton=false
   } else{
      this.pnrDetails="PNR not found "
      this.hidebutton=false

    }
   
  //}, 1500); // 1500 milliseconds (1.5 seconds)
});
  }
  onClick(){
    return new Promise<string[]>(() => {
      setTimeout(() => {
    this.toastMsgService.setMsg({msg : "Work in Progress", msgType : "I"});
  }, 1500); // 1500 milliseconds (1.5 seconds)
});
  }
  onIssue(){
    return new Promise<string[]>(() => {
      setTimeout(() => {
        this.getSessions()
    this.toastMsgService.setMsg({msg : (this.getSession.split("/ETUK/INR32858/31JUL23/DELVS319B/14363904")[0]?.split("PAX 228-")[1]?(`Ticket No `+this.getSession.split("/ETUK/INR32858/31JUL23/DELVS319B/14363904")[0]?.split("PAX 228-")[1]+`\xa0`+"ISSUED SUCCESSFULLY\n"):"No record found"), msgType : "I"})
  }, 1500); // 1500 milliseconds (1.5 seconds)
});
  }
  allPnrs:any
  allCarts:any
  pnrResult:any
  showSpiner:boolean=false
  getPnr(command:any){
    // this.chargerConector.push({tab:this.responseWait});
  this.showSpiner=true
    this.errorNotfound=false

     this.TerminalService
     .getmopnr(command)
     .subscribe({
       next : (res:any) => {
        this.showSpiner=false
        this.hidebutton=true
        console.log(res)
        let data=res
        this.pnrResult=data 
        if(data.result){
        this.allPnrs=data?.result?.pnrData
        this.allCarts=data?.result?.ctData
        this.Officeid=this.allPnrs?.officeID
        this.fopAmt = data?.result?.pnrData.dataElement.fareDetails.totalAmt
        //this.pnrResult.result.fopPresent=false
        if(this.pnrResult?.result?.fopPresent===true){
          this.isPopupHide=true
        }else if(this.pnrResult?.result?.fopPresent===false){
          this.isPopupHide=false
        }
        this.getResult(data)
      }
        if(this.pnrResult.resStatus==='NOT_FOUND'){
          this.errorNotfound=true
          this.isPopupHide=true


        }
       
        
        this.ctDetails = data?.result?.ctNumber
        this.pnrDetails = data?.result?.pnrData?.pnrNumber
        console.log(this.pnrDetails)
        console.log(this.ctDetails)

       },error : (err) => {
        this.showSpiner=false

        this.hidebutton=false
        this.errorNotfound=true
        this.isPopupHide=true
   
       }
     }
   )
   }
   


   getResult(data:any){
    let result:any =""
  if(data?.result?.passengers===undefined){
    console.log(data?.result?.passengers)
    this.pnrDetails="PNR not found \n"
   
    
   // sessionStorage.setItem('data',  this.rtdata);
  }else{
   
    console.log(data)
    sessionStorage.setItem('_data', data?.result?.fullDetail);
   
  
    const passengerInfo = this.getPassengers(data.result?.passengers);
    console.log(passengerInfo.length)
    let passengerCount = passengerInfo.split(" ").length;
    console.log(passengerCount);
    const airInfo = this.getAirInfo(data.result);
    let airinfoCount = airInfo.split("\n").length;
    console.log(airinfoCount)
    const ssrInfo = this.getSSR(data.result);
    console.log(ssrInfo)
    let ssrInfoCount = ssrInfo.split("\n").length;
    let counter = passengerCount+airinfoCount+ssrInfoCount
    result =data.result?.m_longFreeText+"\n"+
    `\xa0`+"RP/"+"DELVS319B/DELVS319B"+`\xa0\xa0\xa0\xa0\xa0\xa0`+`DL/SU`+`\xa0\xa0`+(data.result?.fullDetail?.split('/')[3] ? data.result?.fullDetail?.split('/')[3]:"")+`\xa0\xa0`+(data.result?.amadeusPnr?(data.result?.amadeusPnr+"\n"):""+"\n")+
   // `\xa0`+"1"+`\xa0`+data.result?.passengers[0].lastName+`|`+data.result?.passengers[0].firstName+`|`+data.result?.passengers[0].Title+`\n`+
   // `\xa0`+"2"+`\xa0`+data.result?.airInfo[0].m_carrierCode+data.result?.airInfo[0].m_flightNumber+`\xa0\xa0`+data.result?.airInfo[0].m_bookingClass+`\xa0\xa0`+data.result?.airInfo[0].departureTime?.split('T')[0]+`\xa0\xa0`+data.result?.airInfo[0].m_departureAirport+data.result?.airInfo[0].m_arrivalAirport+`\xa0\xa0`+data.result?.airInfo[0].m_status+`\xa0\xa0`+data.result?.airInfo[0].m_departureTime?.split("T")[1]?.split(":00.000+00:00")[0]+`\xa0\xa0`+data.result?.airInfo[0].m_arrivalTime?.split("T")[1]?.split(":00.000+00:00")[0]+`\xa0\xa0`+data.result?.airInfo[0].departureTime?.split('T')[0]+`\xa0\xa0`+data.result?.airInfo[0].m_ticketType+`\n`+
   passengerInfo+`\n`+
   airInfo+`\n`+
   ssrInfo+`\n`+
    (data.result?.m_mapNumberAndEmail.mobile ? (`\xa0`+ counter++  +`\xa0 `+"AP\xa0") : "")+(data.result?.m_mapNumberAndEmail.mobile ? (data.result?.m_mapNumberAndEmail.mobile+`/`) : "")+(data.result?.m_mapNumberAndEmail.mobile? (data.result?.m_mapNumberAndEmail.email+`\n`) :"")+
    (data.result?.formOfPayment?(`\xa0`+ counter++  +`\xa0`+"FP\xa0"):"")+(data.result?.formOfPayment?(data.result?.formOfPayment+`\n`):"")+
    (data.result?.fullDetail?(`\xa0`+counter++  +`\xa0`+"FA\xa0"):"")+ (data.result?.fullDetail?(data.result?.fullDetail+`\n`):"")+
    (data.result?.endorsementValuesMap[15]?(`\xa0`+counter++  +`\xa0`+"FE\xa0"):"" )+(data.result?.endorsementValuesMap[15]?(data.result?.endorsementValuesMap[15]+`\n`):"" )+
    (data.result?.m_fvToValueMap.FV?(`\xa0`+counter++  +`\xa0`+"FV\xa0"):"")+(data.result?.m_fvToValueMap.FV?( data.result?.m_fvToValueMap.FV+`\n`):"");

      //this.rtdata=result;
    //sessionStorage.setItem('data',  this.rtdata);
   // console.log(result)
   this.pnrDetails=result 

}  


 
   }

   

   getPassengers(passengerData:any){
    
    let passengerInfoArr=[];
    for (let i=0;i<passengerData.length;i++){
      passengerInfoArr.push(`\xa0`+Number(i+1)+`\xa0`+`\xa0`+passengerData[i].lastName+`|`+passengerData[i].firstName+`|`+passengerData[i].Title)
    
    }
    let passengerInfo = passengerInfoArr.join("\xa0");
    return passengerInfo
   }
    
   
   getAirInfo(allData:any){
    let passengerData = allData.passengers 
    console.log(passengerData.length)
    let airInfoCounter = passengerData.length;
    console.log(airInfoCounter)
    let airInfoArr = [];
    let airInfoData = allData.airInfo
     for (let i=0;i<airInfoData.length;i++){ 
        if (airInfoData[i].m_check_in_time && airInfoData[i].m_check_in_time!=""){
         airInfoCounter++
         airInfoArr.push(`\xa0`+airInfoCounter +`\xa0`+`\xa0`+airInfoData[i].m_carrierCode+airInfoData[i].m_flightNumber+`\xa0\xa0`+airInfoData[i].m_bookingClass+`\xa0\xa0`+this.formatDate(airInfoData[i].departureTime?.split('T')[0])+`\xa0\xa0`+airInfoData[i].m_weekDay+`\xa0\xa0`+airInfoData[i].m_departureAirport+airInfoData[i].m_arrivalAirport+`\xa0\xa0`+airInfoData[i].m_status+`\xa0\xa0`+airInfoData[i].m_departureTime?.split("T")[1]?.split(":00.000+00:00")[0]+`\xa0\xa0`+airInfoData[i].m_arrivalTime?.split("T")[1]?.split(":00.000+00:00")[0]+`\xa0\xa0`+this.formatDate(airInfoData[i].departureTime?.split('T')[0])+`\xa0\xa0`+airInfoData[i].m_ticketType)
        }
    }

    console.log(airInfoCounter)
    let airInfo = airInfoArr.join("\n")
    return airInfo 
   }

   getSSR(allData:any){
    let passengerData = allData.passengers 
    console.log(passengerData.length)
    
    
    let airInfoData = this.getAirInfo(allData).split("\n")
    let ssrCounter = passengerData.length+airInfoData.length;
    console.log(ssrCounter)
    let ssrData = allData.m_SSRDataElements
    let ssrDataArr=[];

    for (let i=0;i<ssrData.length;i++){ 
      const cssrCmpanyId = ssrData[i].companyId?ssrData[i].companyId+`|`:"";
      const cssrfreeText=ssrData[i].freeText?ssrData[i].freeText+`|`:"";
      const cssQuantity=ssrData[i].quantity?ssrData[i].quantity+`|`:"";
      const cssrStatus=ssrData[i].status?ssrData[i].status+`|`:"";
      const cssrType=ssrData[i].type?ssrData[i].type:"";
      ssrCounter++
      if(cssrCmpanyId!="" ||cssrfreeText!=""||cssQuantity!=""||cssrStatus!=""||cssrType!=""){
      ssrDataArr.push(`\xa0`+ssrCounter+`\xa0`+`\xa0`+"SSR"+`\xa0`+`\xa0`+cssrCmpanyId+cssrfreeText+cssQuantity+cssrStatus+cssrType)
    }
    }
    let ssrInfo = ssrDataArr.join("\n");
    return ssrInfo
   }
   getdata(){
    this.getdataa=sessionStorage.getItem('data')
    return sessionStorage.getItem('my_data');
   }
   getSessions(){
    console.log(sessionStorage.getItem('_data'))
    this.getSession=sessionStorage.getItem('_data')
    return sessionStorage.getItem('my_data');
   }

   formatDate(val:Date){
    let value:any = ""
    if(val){
    let datepipe = new DatePipe("en");
    value = datepipe.transform(val, "ddMMM")?.toUpperCase();
    }
    
      return value
    
  }
  openPopup(){
    this.isPopupHide=false
  }
  closePopup(){
    this.fopType="CASH"
   this.isPopupHide=true
  }

getSourceConfig(){
   
  this.AirConfigService
  .getSourceForOfficeId()
  .subscribe({
    next : (res:any) => {
      if(res) {
        let data=res
        console.log(data)
        for(let i=0;i<data.length;i++){
       if(data[i].officeId!=null){
         if(data[i].sourceCode==='32'){
          console.log(data[i])
         this.Officeid=data[0].officeId
         this.sourceList.push(data[i].officeId)
         //console.log(this.sourceList)
        }
       }}
       
         
       
       
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}

updateFOPPnr(){
  // this.chargerConector.push({tab:this.responseWait});

  this.errorNotfound=false
  let pnrAddMultiFOPReq :any;
  if(this.fopType==="CA"){
    pnrAddMultiFOPReq = {
      "pnrNumber":this.pnrNo,
      "identification":this.fopType,
      //"amount":6353,
      "amount":this.fopAmt,
      "currencyCode":"INR"
  }
  }
  else{
    pnrAddMultiFOPReq = {
      "pnrNumber":this.pnrNo,
      "identification":this.fopType,
      //"amount":6353,
     "amount":this.fopAmt,
      "currencyCode":"INR",
      "cardNumber":this.cardNo
  }
  }
  console.log(pnrAddMultiFOPReq)
  this.TerminalService
   .updateFOPPNR(pnrAddMultiFOPReq)
   .subscribe({
     next : (res:any) => {

      this.getPnr(this.pnrNo);
     },error : (err) => {
      this.getPnr(this.pnrNo);
     }
    })
   }

   docIssuance(){
    // this.chargerConector.push({tab:this.responseWait});
  
    this.errorNotfound=false

     this.TerminalService
     .docIssaunce(this.pnrNo)
     .subscribe({
       next : (res:any) => {
        this.getPnr(this.pnrNo);
       }
       ,error : (err) => {
        this.getPnr(this.pnrNo);
       }
      })
     }

CreditData:any
creditList(){

  this.PaymentConfigService
  .creditCardList()
  .subscribe({
    next : (res:any) => {
      if(res) {
        let data=res
     this.CreditData=data
     console.log(this.CreditData)
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}
onChageFop(){
  if(this.fopType==='CASH'){
  this.cardNo=""
  this.cardExpMonth=""
  this.cardExpYear=""}
}
cardData(item:any){
this.cardNo=item.maskedCardNumber
/*if(item.expiryDate){
this.cardExpMonth=this.separateValues(item.expiryDate).month
this.cardExpYear=this.separateValues(item.expiryDate).year
}*/
}

separateValues(data: string): { month: string, year: string } {
      
  const parts = data.split('/');
  
  if (parts.length === 2) {
    return {
      month: parts[0].trim(),
      year: parts[1].trim()
    };
  } else {
    // Handle the case where the input string doesn't have the expected format
    // You might want to throw an error or handle it in a way that fits your application logic.
    return {
      month: '',
      year: ''
    };
  }
}
}
